import React from "react";
import { useGlobalLoading } from "../context/GlobalLoadingContext";

const GlobalLoadingOverlay = () => {
  const { isGlobalLoading } = useGlobalLoading();

  if (!isGlobalLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        backgroundColor: "rgba(255, 249, 230, 1)",
      }}
    >
      <div style={{ textAlign: "center", color: "white" }}>
        {/* Logo from public */}
        <img
          src="/Frame2.png"
          alt="SYUKRA"
          style={{ width: 150, height: "auto", marginBottom: 28 }}
        />

        {/* Horizontal infinite bar */}
        <div
          style={{
            position: "relative",
            width: 170,
            height: 3,
            backgroundColor: "rgba(112, 112, 112, 0.45)",
            overflow: "hidden",
            borderRadius: 999,
            margin: "0 auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: "-40%",
              top: 0,
              bottom: 0,
              width: "40%",
              background:
                "linear-gradient(90deg, rgba(0, 0, 0, 0.2), #000000ff, rgba(0, 0, 0, 0.2))",
              borderRadius: 999,
              animation: "global-loading-bar-slide 1.1s infinite ease-in-out",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GlobalLoadingOverlay;
